import ParseEntry from './parser'
export default ParseEntry
